import React, { useEffect, useState, useRef } from 'react';
import close_button from '../../../assets/close_button.png';
import PmModuleStyle from '../styles/pm.module.css';
import Highcharts from 'highcharts';
require('highcharts/modules/accessibility')(Highcharts);
// require('highcharts/modules/mouse-wheel-zoom.js')(Highcharts);

const TaskCostGraph = ({ type, isDecisionPopup, showDecisionPopupHandler, hideDecisionPopupHandler, simObj, setSimObj, isResult, summaryGraphData, seriesStatus, setSeriesStatus, attempt }) => {
  const [gGraphStyle, setGGraphStyle] = useState({ left: 0, top: 0 });
  const [monthlydata, setMonthlyData] = useState('');
  const [TaskCostData, setTaskCostData] = useState({ "EXPECTED": [], "ACTUAL": [] });
  const [CostsData, setCostsData] = useState({ "monthly": [], "quarterly": [], "yearly": [] });
  const [xAxisMinMax, setXAxisMinMax] = useState({ "monthly": { min: 1, max: 31 }, "quarterly": { min: 0, max: 3 }, "yearly": { min: 0, max: 12 } });
  const [dpObject, setDpObject] = useState({});
  const [isShowD, setIsShowD] = useState(true);
  const [TaskCostGraphLabel, setTaskCostGraphLabel] = useState("");
  const [chart, setChart] = useState(null);
  const prevDataRef = useRef();
  const [tasksInfo, setTasksInfo] = useState([]);
  //let currentState = [];

  let graphSettings = {}
  function getMonthDays(year, month) {
    // Months are 0-based in JavaScript (0 - January, 1 - February, ..., 11 - December)
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
  }
  const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = { year: 'numeric', month: 'long' };
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      dateObject = new Date(date.replace(/-/g, "/"));
    }
    return dateObject.toLocaleDateString(navigator.language, options);
  }
  const setGraphData = () => {
    if (chart != undefined) {
      //debugger;
      let TaskExpectedCost;
      let TaskActualCost;
      (chart && chart?.yAxis && chart?.yAxis[0]) && chart?.yAxis[0]?.update({ min: 0, max: undefined });
      //TaskExpectedCost
      // if (simObj && simObj.graphdata && typeof simObj.graphdata.tasks === 'object') {
      //   TaskExpectedCost = simObj?.graphdata?.tasks;
      //   TaskExpectedCost = (TaskExpectedCost != undefined ? TaskExpectedCost : []).map((data) => {
      //     return {
      //       x: data.taskId,
      //       y: Math.floor(data.actualCost), //need here expectedCost
      //       currentState: data.currentState
      //     }
      //   });
      // }
      // setTaskCostData(prevData => ({
      //   ...prevData,
      //   EXPECTED: TaskExpectedCost,
      // }));
      // if (TaskExpectedCost?.length != (chart?.series && Array.isArray(chart.series) && chart?.series[0]?.data?.length)) {
      //   chart?.series && chart?.series[0]?.setData(TaskExpectedCost?.map((it) => it.y));
      // }

      //TaskActualCost
      if (simObj && simObj?.graphdata && typeof simObj?.graphdata?.tasks === 'object') {
        TaskActualCost = simObj?.graphdata?.tasks;
        TaskActualCost = (TaskActualCost != undefined ? TaskActualCost : []).map((data) => {
          return {
            x: data.taskId,
            y: Math.floor(data.actualCost),
            currentState: data.currentState
          }
        });
      }
      setTaskCostData(prevData => ({
        ...prevData,
        ACTUAL: TaskActualCost,
      }));
      //if (true) { //TaskActualCost?.length != (chart?.series && Array.isArray(chart.series) && chart?.series[1]?.data?.length)
      const seriesData0 = TaskActualCost?.map((currItem) => {
        return currItem.y;
      });
      chart?.series && chart?.series[0]?.setData(seriesData0);
      const seriesData1 = TaskActualCost?.map((currItem) => {
        const dataPoint = {
          y: 0, // Default value for "NOT_STARTED"
          currentState: currItem.currentState
        };
        if (currItem.currentState === "IN_PROGRESS" || currItem.currentState === "COMPLETED") {
          dataPoint.y = currItem.y; // or assign the value based on your plotting mechanism
        }
        return dataPoint;
      });
      setSeriesStatus(seriesData1);
      chart?.series && chart?.series[1]?.setData(seriesData1);
      //}
      chart?.xAxis && chart?.xAxis[0]?.setCategories(TaskActualCost?.map((it) => it.x));
    }
    (simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && (chart && chart?.yAxis && chart?.yAxis[0]) && chart?.yAxis[0].update({ min: 1, max: 30 })
  }

  function applyAccessibility(chart) {
    if (chart && chart.renderTo) {
      const svg = chart.renderTo.querySelector("svg.highcharts-root");
      if (svg) {
        setTimeout(() => {
        svg.setAttribute('role', 'img');

        svg.setAttribute('aria-label', 'Chart showing expected and actual task costs for tasks A to Z.');

        const oldDesc = svg.querySelector("desc");
        if (oldDesc) oldDesc.remove();

        const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
        desc.textContent = "This chart compares the expected and actual costs for tasks labeled A through Z. The orange diagonal-striped bars represent the expected task cost, while the blue diagonal-striped bars represent the actual task cost in dollars.";
        svg.insertBefore(desc, svg.firstChild);
        },0);
      }
    }
  }

  graphSettings = {
    plotOptions: {
      series: {
        //stickyTracking: false,
        marker: {
          enabled: true,
        },
        //pointPlacement: "on",
        dataLabels: {
          enabled: false,
        },
      },
      states: {
        inactive: {
          enabled: false
          //opacity:1
        },
      },
    },
    chart: {
      type: "column",
      responsive: false,
      marginRight: 15,
      // marginTop: 3,
      height: 240,
      plotBorderWidth: 1,
      events: {
            render: function () {
            applyAccessibility(this);
            },
            redraw: function () {
            applyAccessibility(this);
            }
      }
    },
    title: null,
    legend: {
      enabled: false,
    },
    xAxis: {
      categories: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      gridZIndex: 4,
      tickInterval: 1,
      startOnTick: true,
      title: {
        text: "Task",
        style: {
          fontWeight: 'bold',
          fontSize: '13px',
          color: "#000"
        },
      },
      labels: {
        rotation: 0,
        step: 1,
        style: {
          fontSize: '0.8em'
        }
      }
    },
    yAxis: {
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 4,
      startOnTick: true,
      tickLength: 10,
      tickWidth: 1,
      tickColor: '#C6C6C3',
      color: 'rgb(255,255,255)',
      title: {
        text: "Cost",
        style: {
          fontWeight: 'bold',
          fontSize: '13px',
          color: "#000"
        }
      },
      labels: {
        formatter: function () {
          var valueInK = this.value / 1000; // Convert value to thousands
          if (valueInK >= 1) {
            return Highcharts.numberFormat(valueInK, 0, ',', ',') + 'K'; // Format with 'K' for thousands
          }
          return this.value; // Display values less than 1000 without 'K'
        }
      },
      // tickInterval: 2000000,
      gridLineWidth: 0,

    },
    accessibility: {
      enabled: true,
      description: '',
      pointDescriptionFormatter: function (point) {
        // Customize the aria-label for each point
        return `${point.category}: ${(simObj?.tasksInformation != undefined) ? simObj?.tasksInformation?.filter((item, index) => index == point.index)[0]?.taskName : ``}; ${(point.y != undefined) ? `${point.series.name}: ${point.y}` : ``}; ${(prevDataRef.current != undefined) ? `Task Status: ${prevDataRef.current?.filter((item, index) => index == point.index)[0]?.currentState}` : ``}; `;
      },
      keyboardNavigation: {
        enabled: true, // Enable keyboard navigation
      },
      screenReaderSection: {
        beforeChartFormat: '' // disables their auto "Interactive chart" label
      }
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: "Expected Cost",
        borderWidth: 1,
        borderRadius: 0,
        states: {
          hover: {
            borderWidth: 1, // Border width on hover
            borderColor: 'black' // Border color on hover
          }
        },
        data: [],
        color: {
          pattern: {
            path: 'M 0 10 L 10 0',
            width: 10,
            height: 10,
            color: '#FFFFFF',
            backgroundColor: "#D93300"
  
          }
        },

      },
      {
        name: "Actual Cost",
        borderWidth: 1,
        borderRadius: 0,
        crisp: true,
        states: {
          hover: {
            borderWidth: 1, // Border width on hover
            borderColor: 'black' // Border color on hover
          }
        },
        data: [],
        color: {
          pattern: {
            path: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
            width: 10,
            height: 10,
            color: '#FFFFFF',
            backgroundColor: '#005A70'
          },
        }
      }
    ],
    tooltip: {
      hideDelay: 0,
      shared: true,
      crosshairs: true,
      borderWidth: 1,
      //backgroundColor:'#F8F8F8',
      style: {
        borderColor: function () {
          return this.point.color; // Set the tooltip box border color to match the point color
        },
        opacity: 0.9,
        fontSize: '14px',
      },
      formatter: function () {
        return '<strong style="font-size:12px">' + (this.point.category) + ': ' + simObj?.tasksInformation?.filter((item, index) => index == this.point.index)[0]?.taskName + '</strong><br/>' + this.points.map(point => '<span style="font-weight:bold;font-size:12px;color:' + (point.series.name === "Expected Cost" ? "#D93300" : point.series.name === "Actual Cost" ? "#005A70" : "" ) + ';padding:0">' + point.series.name + '</span>: <strong style="font-size:12px;">' + Highcharts.numberFormat(point.y, 0, ',', ',') + '</strong>').join('<br>') + '<br><span style="font-weight:bold;font-size:12px;padding:0">' + `Task Status: ` + prevDataRef.current?.filter((item, index) => index == this.point.index)[0]?.currentState + '</span>';
      }

    }

  }
  useEffect(() => {
    // Save the current data to prevDataRef
    prevDataRef.current = seriesStatus;
  }, [seriesStatus]);

  useEffect(() => {
    const newChart = Highcharts.chart("TaskCost-Graph", graphSettings);
    setChart(newChart);
    // if (type === "monthly" || type === "quarterly" || type === "yearly") {
    //   const g_container = PmModuleStyle['graph-container'];
    //   let gContainer = document.getElementsByClassName(`${g_container}`)[1];
    //   gContainer.setAttribute("tabindex", '-1');
    //   gContainer.focus();
    // }
    //Added for xaxis type quarterly resizable.

  }, [type, tasksInfo]);

  useEffect(() => {
    if (tasksInfo?.length == 0 && simObj?.tasksInformation) {
      setTasksInfo(simObj?.tasksInformation)
    }
  }, [simObj?.tasksInformation]);

  useEffect(() => {
    if (isResult && chart != undefined) {
      chart && chart.series && chart?.series[0]?.setData([]);
      chart && chart.series && chart?.series[1]?.setData([]);
      setSimObj((prevObj) => ({
        ...prevObj,
        graphdata: summaryGraphData,
      }));
    }
    else {
      setGraphData();
    }
    if (chart != undefined) {
      setTaskCostGraphLabel(`Expected Cost and Actual Cost graphs representing along Y-axis with ${chart?.yAxis != undefined && chart?.yAxis[0].tickInterval} per unit scale.`);
      document.querySelector("#TaskCost-Graph").setAttribute('role', `figure`);
      document.querySelector("#TaskCost-Graph .highcharts-container ").setAttribute('tabindex', '0');
    }
  }, [chart, simObj?.graphdata, summaryGraphData]);
  useEffect(() => {
    if (isResult) {
      setGraphData();
    }
  }, [simObj, isResult, summaryGraphData])


  return (
    <div className={`${PmModuleStyle['graph-container']}`} >
      {/* {!simObj?.graphdata?.length && <div className={`${PmModuleStyle['nodata-alert-TaskCost']}`}>Task Cost will appear here as the simulation runs</div>} */}
      <span></span>
      {/* <a href="#" onClick={(e)=> e.preventDefault()} aria-label="Legends: line with round bullet for Revenue and line with Rhombus got Cost of Quality" className="sr-only"></a> */}
      <div id="TaskCost-Graph" className={`${PmModuleStyle['revenue-graph']}`} aria-label={TaskCostGraphLabel} role='figure'>
      </div>
    </div>
  )
}

export default TaskCostGraph